module.exports = __webpack_public_path__ + "img/2011-3.e32c3cd0.jpg";